import { PageSection, PageSectionData } from "../PageSection";
import { Section, SectionData } from "../Section";

class SectionFactory {
  static createSection(section: SectionData): Section {
    switch (section.discriminator) {
      case "PAGE": {
        return new PageSection(section as PageSectionData);
      }
      default: {
        throw new Error(`Unknown Section Type ${section.discriminator}`);
      }
    }
  }
}

export { SectionFactory };
